module.exports = __webpack_public_path__ + "static/media/250221_LD-2025202A_LP285A6NW01.04219e2f.pdf";